
import { useContext } from 'react';
import { AgentDef } from '../../apis/mgmt/api';
import { readOnly } from '../common/DataView';
import { ListProps, ListWithCreateButtonLayout } from '../common/List';
import { AgentDefCard } from './AgentDefCard';
import { Auth, Role } from '../../apis/Auth';

export function AgentDefList(props: ListProps<AgentDef>) {

    const { onAddItem, onEditItem } = props;
    const { is } = useContext(Auth);

    return (
        <ListWithCreateButtonLayout onCreateClick={is(Role.TECHNICIAN) && onAddItem || undefined}>
            {props.data && props.data.map((itemData: AgentDef) => (
                <AgentDefCard
                    key={itemData.id}
                    data={itemData}
                    {...readOnly}
                    onClick={onEditItem}
                />
            ))}
        </ListWithCreateButtonLayout>
    );

}